import { gql } from '@apollo/client';
import { client } from 'client';

/**
 * @deprecated - This function should not be used, useQuery/useMutation are the primary method for performing queries/mutations.
 */
export default async function componentQuery(query, variables, noGql, fetchPolicy, onError) {
  try {
    const response = await client.query({
      query: noGql
        ? query
        : gql`
            ${query}
          `,
      variables: variables,
      fetchPolicy: fetchPolicy,
    });

    return { response: response.data, errors: response.errors };
  } catch (e) {
    if (onError) return e;
    console.error('Query error', e);

    return {
      response: e?.networkError?.response,
      errors: e?.networkError?.result?.errors,
    };
  }
}
